module.exports = __webpack_public_path__ + "img/4_157.cac91558.png";